import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import RemoveIcon from '@mui/icons-material/Remove';
import { brand } from 'themes/brand';

const LEGEND_ITEMS: {
  Icon: React.ElementType;
  color: string;
  label: string;
}[] = [
  { Icon: AccessTimeIcon, color: '#d97706', label: 'Aguardando envio' },
  { Icon: CheckIcon, color: brand.glow, label: 'Enviada' },
  { Icon: DoneAllIcon, color: brand.primary, label: 'Entregue' },
  { Icon: DoneAllIcon, color: '#16a34a', label: 'Lida' },
  { Icon: WarningAmberIcon, color: '#dc2626', label: 'Falha no envio' },
  { Icon: RemoveIcon, color: '#9ca3af', label: 'Sem mensagem disparada' },
];

export function WhatsappStatusLegend() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        fontSize: '0.75rem',
        color: brand.textSecondary,
        flex: 1,
      }}
    >
      <span style={{ fontWeight: 600, color: brand.text }}>Legenda:</span>
      {LEGEND_ITEMS.map(({ Icon, color, label }) => (
        <span
          key={label}
          style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 16,
              height: 16,
              borderRadius: '50%',
              backgroundColor: `${color}2e`,
              flexShrink: 0,
            }}
          >
            <Icon style={{ width: 10, height: 10, color }} />
          </span>
          {label}
        </span>
      ))}
    </div>
  );
}
